import { createReducer } from '../../util';
import * as actions from '../actions/chargeAnalysis';
import { StatusState } from './common';

const initialStatusState : StatusState = {
    error: false,
    errorMessage: '',
    pending: false,
};

const initialState = {
    stats: {},
    relativeFilterValue: '',
    claimId: null,

    getStats: {
        ...initialStatusState
    },
    download: {
        ...initialStatusState
    },
};

export default createReducer(initialState, {
    [actions.CHARGE_ANALYSIS_STATISTICS_PENDING]: (state) => ({
        ...state,
        getStats: {
            pending: true,
        },
    }),
    [actions.CHARGE_ANALYSIS_STATISTICS_FULFILLED]: (state, stats) => ({
        ...state,
        getStats: {
            ...initialStatusState,
        },
        stats,
    }),
    [actions.CHARGE_ANALYSIS_STATISTICS_REJECTED]: (state, errorMessage) => ({
        ...state,
        getStats: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.CHARGE_ANALYSIS_SET_RELATIVE_FILTER]: (state, { relativeFilterValue }) => ({
        ...state,
        relativeFilterValue,
    }),
    [actions.CHARGE_ANALYSIS_DOWNLOAD_REPORT_PENDING]: (state) => ({
        ...state,
        download: {
            pending: true,
        },
    }),
    [actions.CHARGE_ANALYSIS_DOWNLOAD_REPORT_FULFILLED]: (state) => ({
        ...state,
        download: {
            ...initialStatusState,
        },
    }),
    [actions.CHARGE_ANALYSIS_DOWNLOAD_REPORT_REJECTED]: (state, errorMessage) => ({
        ...state,
        download: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.CHARGE_ANALYSIS_SET_CLAIM_ID]: (state, { claimId }) => ({
        ...state,
        claimId,
    }),
});